import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_OR_TABLET_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const value: 'a' | 'b' | 'c' | undefined = getFeature('tariff-selection-poll');

if (!IS_MOBILE_OR_TABLET_BROWSER) {
    registerExperiment(
        'tariff-poll',
        value,
        [
            AnalyticEventNames.ASIDE_POLL_SHOW,
            AnalyticEventNames.ASIDE_POLL_START,
            AnalyticEventNames.ASIDE_POLL_RESULTS_SHOW,
            AnalyticEventNames.ASIDE_POLL_RESULTS_CLICK,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        ],
        {
            sendXrayArgs: {
                [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => ({
                    eventName: paySource?.startsWith('survey_suitable_tariff_web_cloud') ? 'tariff_slct_checkout' : eventName,
                }),
            },
        }
    );
}

export const abTariffSelection = value;
